import { render, staticRenderFns } from "./ImportResource.vue?vue&type=template&id=99fb705c&scoped=true"
import script from "./ImportResource.vue?vue&type=script&lang=js"
export * from "./ImportResource.vue?vue&type=script&lang=js"
import style0 from "./ImportResource.vue?vue&type=style&index=0&id=99fb705c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fb705c",
  null
  
)

export default component.exports